<template>
  <v-row no-gutters class="user pl-3" v-if="!$store.state.user ">
    <v-col>
      <v-icon color="white">mdi-account-box</v-icon>
      <span class="white--text">{{ text.common.login }}</span>
      <v-menu v-model="menu" :close-on-content-click="false" offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon color="white">mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-card>
          <UserLoginForm/>
        </v-card>
      </v-menu>
    </v-col>
  </v-row>
  <UserLogged v-else/>
</template>

<script>
import { translations } from '@/lang/translations';
import UserLoginForm from '../UserLoginForm.vue';
import UserLogged from './UserLogged.vue';

export default {
  name: 'User',
  components: {
    UserLoginForm,
    UserLogged,
  },
  data() {
    return {
      menu: false,
      hints: false,
      message: false,
      fav: true,
    };
  },
  computed: {
    text() {
      return translations[this.$store.state.language];
    },
  },
};
</script>

<style scoped>
.user {
  margin-top: -0.7em;
}

.white {
  color: #ffffff;
}
</style>
